// Duitse teksten voor gemiste taken in de ouderapp (zie missedApp.nl.ts).
export const appMissedDe = {
    line: {
        one: '{count} Aufgabe in der letzten Woche verpasst',
        other: '{count} Aufgaben in der letzten Woche verpasst',
    },
    lineSub: 'Nachträglich abhaken oder überspringen',
    open: 'Ansehen',
    title: 'Verpasst',
    description: 'Aufgaben der letzten Woche, die offen geblieben sind. Hake sie nachträglich ab oder überspringe sie. Punkte zählen wie an dem Tag.',
    done: 'Doch erledigt',
    doneLabel: 'Doch erledigt: {title}, {name}',
    skip: 'Überspringen',
    skipLabel: 'Überspringen: {title}, {name}',
    undo: 'Rückgängig',
    undoLabel: 'Rückgängig: {title}, {name}',
    markedDone: '{title} nachträglich abgehakt',
    markedSkipped: '{title} übersprungen',
    undone: '{title} steht wieder unter verpasst',
    stateDone: 'Erledigt',
    stateSkipped: 'Übersprungen',
    allDone: 'Nichts mehr verpasst. Alles ist aktuell.',
};
//# sourceMappingURL=missedApp.de.js.map